import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchTranslations(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/translations/get-all/${queryParams.locale}`, { params: queryParams })
          .then(response => {
            resolve(response)
          })
          .catch(error => reject(error))
      })
    },
    fetchTranslation(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/translations/get-details?id=${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    addUser(ctx, userData) {
      console.log('userData', userData)
      return new Promise((resolve, reject) => {
        axios
          .post('/users/add-user', { data: userData })
          .then(response => {
            console.log('response', response)
            resolve(response)
          })

          .catch(error => reject(error.response))
      })
    },
    editUser(ctx, userData) {
      console.log('Edit', userData)
      return new Promise((resolve, reject) => {
        axios
          .post('/users/edit-user', { data: userData })
          .then(response => {
            console.log('response', response)
            resolve(response)
          })

          .catch(error => reject(error.response))
      })
    },
  },
}
